// extracted by mini-css-extract-plugin
export default {"padded":"Card_padded__MgK8v"};